import { useEffect } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import useMainStore from "../store";

// const apiUrl = configs.API_URL;

// export function useUser({ redirectTo, redirectIfFound } = {}) {
//     const { data, error } = http.get(`${apiUrl}/user`);
//     const user = data?.user
//     const finished = Boolean(data)
//     const hasUser = Boolean(user)
//
//     useEffect(() => {
//         if (!redirectTo || !finished) return
//         if (
//             // If redirectTo is set, redirect if the user was not found.
//             (redirectTo && !redirectIfFound && !hasUser) ||
//             // If redirectIfFound is also set, redirect if the user was found
//             (redirectIfFound && hasUser)
//         ) {
//             // Router.push(redirectTo)
//         }
//     }, [redirectTo, redirectIfFound, finished, hasUser])
//
//     return error ? null : user
// }
export function useUser({ redirectTo, redirectIfFound } = {}) {
  const [cookies, setCookie, removeCookie] = useCookies();

  const user = localStorage.getItem('user-data');
  const accessToken = cookies?.['access-token'];

  const hasUser = Boolean(user && accessToken);
  const navigate = useNavigate();
  const {sessionUpdated} = useMainStore();

  useEffect(() => {
    if (!redirectTo) return;
    if (
      // If redirectTo is set, redirect if the user was not found.
      (redirectTo && !redirectIfFound && !hasUser) ||
      // If redirectIfFound is also set, redirect if the user was found
      (redirectIfFound && hasUser)
    ) {
      navigate(redirectTo);
    }
  }, [redirectTo, redirectIfFound, hasUser]);
  // This will trigger when session updated and user gets Updated
  useEffect(() => {}, [sessionUpdated]);

  return JSON.parse(user);
}
